export type CustomerPrivacyCategory =
    | 'location'
    | 'address'
    | 'station'
    | 'org'
    | 'person'
    | 'email'
    | 'endpoint'
    | 'ocpiProfile'
    | 'serial'
    | 'randomNumber';

export const MaskData: {
    [category in CustomerPrivacyCategory]: string[];
} = {
    email: [],
    endpoint: ['wss://i8a9jja.ocpp.acme.com/ocpp16j/K0082104'],
    location: [
        'C-Mart Bangkok',
        'Miass',
        'Upper Hutt',
        'Saint-Louis',
        'Ipís',
        'Carmen de Bolivar',
        'Göteborg',
        'Envigado',
        'Çaldıran',
        'Ede',
        'Cambrai',
        'Yeoju',
        'Nagaon',
        'Segovia',
        'Okigwe',
        'Tampa',
        'Rawalakot',
        'San Giovanni la Punta',
        'Naninne',
        'Yaroslavl',
        'Belfast',
        'Seongnam',
        'Forio',
        'Breda',
        'Monceau-sur-Sambre',
        'Lo Prado',
        'Changwon',
        'Lewiston',
        'Temuka',
        'Topeka',
        'Curacautín',
        'Skardu',
        'Bloomington',
        'Bay Roberts',
        'Pogliano Milanese',
        'Kettering',
        'Laurencekirk',
        'Gillette',
        'Sydney',
        'Uyo',
        'Dannevirke',
        'Volgograd',
        'Jinju',
        'Galway',
        'Hamburg',
        'Sherani',
        'Saint-Malo',
        'Masterton',
        'Calera de Tango',
        'Hofors',
        'Salvador',
        'Hafizabad',
        'Yaxley',
        'Belfast',
        'Dublin',
        'Upper Hutt',
        'Ankara',
        'Ham-sur-Sambre',
        'Oaxaca',
        'Gore',
        'Vienna',
        'Combarbalá',
        'Gimhae',
        'Neder-Over-Heembeek',
        'Batu',
        'Workington',
        'Kraków',
        'Hanam',
        'Konin',
        'Mogliano',
        'Berlin',
        'Greater Sudbury',
        'Semarang',
        'Chimbarongo',
        'Topeka',
        'Penrith',
        'Berlin',
        'Chandler',
        'Clydebank',
        'Parepare',
        'Hamburg',
        'Blitar',
        'Derby',
        'Bydgoszcz',
        'Matamata',
        'Pontianak',
        'Şanlıurfa',
        'Nederhasselt',
        'Berlin',
        'Berlin',
        'Barranco Minas',
        'Portland',
        'Mata de Plátano',
        'Minna',
        'Arequipa',
        'Forfar',
        'Toulon',
        'Rionegro',
        'Auldearn',
        'Merrickville-Wolford',
        'Jönköping',
    ],
    address: [
        '8238 In Av.',
        '7614 Elementum Rd.',
        '100-8541 Morbi Avenue',
        '9463 Ac St.',
        '658-1813 Diam Road',
        '2902 Erat. Road',
        '115-8518 Elit Ave',
        '758-4139 Diam Ave',
        '1094 Congue Road',
        '3212 Hymenaeos. Street',
        '600-9623 In St.',
        '3795 Sem Avenue',
        '2083 Tristique Av.',
        '4131 Aliquet Road',
        '411-2277 Lectus Avenue',
        '107-4113 Commodo St.',
        '5694 Quisque Rd.',
        '473-9414 Libero. Av.',
        '1348 Amet Ave',
        '247-3991 Nam Rd.',
        '8781 Ullamcorper Ave',
        '334-9408 Sed, Road',
        '8047 Nec Street',
        '244-375 Vivamus Ave',
        '590-2633 Donec Street',
        '426-7372 Montes, Rd.',
        '619-3577 Magna. St.',
        '6937 Aliquam Rd.',
        '4779 Donec Avenue',
        '1309 Sagittis. Rd.',
        '735-5814 Netus St.',
        '4757 Suscipit St.',
        '2512 Ultrices, St.',
        '6623 Nunc Street',
        '489-7835 Sociosqu Rd.',
        '8810 Magna. Ave',
        '129-1527 Interdum Rd.',
        '5650 Dis Road',
        '1422 Accumsan St.',
        '733-4053 Duis Rd.',
        '517-6856 Ante Road',
        '7990 Sed Road',
        '431-933 Class Avenue',
        '628-4928 Nulla. Avenue',
        '3022 Primis Avenue',
        '753-618 Nunc St.',
        '1159 Parturient Road',
        '708-6230 Lobortis. Rd.',
        '404 Convallis Rd.',
        '161-6866 Sed Avenue',
        '1347 Dictum Road',
        '3168 Maecenas Ave',
        '704-6157 Ligula. Road',
        '9989 Ligula Road',
    ],
    station: [
        // custom logic in customer privacy pipe
    ],
    org: [
        'Cras Interdum Nunc Institute',
        'Enim Non Nisi Associates',
        'Odio A Purus Consulting',
        'Acme Corp',
        'Sapien Nunc LLP',
        'A+ Industries',
        'Ultrices Mauris Inc.',
        'Ipsum LLP',
        'Eu Corp.',
        'Gravida Praesent Ltd',
        'Semper LLC',
        'Hendrerit Inc.',
        'A Nunc Associates',
        'Dictum Mi Limited',
        'Nam Nulla Magna Corporation',
        'Ac Feugiat Non Inc.',
        'Non Ante Bibendum LLP',
        'Nullam Nisl Maecenas Corp.',
        'Nulla Tempor Augue Industries',
        'Et Nunc Quisque Foundation',
        'Dolor Quisque Tincidunt Company',
        'Sem Ltd',
        'Nascetur Corporation',
        'Placerat Augue Incorporated',
        'Hendrerit Industries',
        'Dapibus Incorporated',
        'Et Lacinia Ltd',
        'Tempus Lorem Fringilla Limited',
        'Diam Proin Dolor Inc.',
        'Quis Accumsan Consulting',
        'Semper Corporation',
        'Mauris Id LLP',
        'Nonummy Ut Incorporated',
        'Dolor Dapibus Inc.',
        'Amet Luctus Institute',
        'Augue Limited',
        'Tellus LLP',
        'Iaculis Lacus Incorporated',
        'Erat Inc.',
        'Sit Amet Ultricies PC',
        'Tincidunt Nunc Ac Foundation',
        'Rutrum Corp.',
        'Luctus Sit LLC',
        'Arcu LLC',
        'Sociis Natoque Penatibus Associates',
        'Leo Cras Vehicula PC',
        'Blandit Corporation',
        'Sit Amet Consectetuer LLP',
        'Malesuada Limited',
        'Gravida Molestie Arcu Associates',
        'Donec Egestas Institute',
        'Scelerisque Lorem Ltd',
        'Quis Massa Mauris Ltd',
        'Arcu Imperdiet Ltd',
        'Posuere LLC',
        'Donec Nibh Enim Consulting',
        'Sem Magna Nec LLC',
        'Semper Auctor Limited',
        'Risus Morbi Metus Corp.',
        'Placerat Eget Venenatis PC',
        'Convallis In Incorporated',
        'Suspendisse Commodo Company',
        'Accumsan Sed Corp.',
        'Amet Ornare Consulting',
        'Accumsan Neque Et Incorporated',
        'Aliquam Adipiscing Corporation',
        'Ac Nulla In Inc.',
        'Semper Cursus Integer Foundation',
        'Non Magna Nam Corp.',
        'Enim Company',
        'Tempus Risus Donec Ltd',
        'Sem Consequat Nec Company',
        'Pellentesque A Facilisis Ltd',
        'Phasellus Nulla Industries',
        'Scelerisque Neque Nullam Corporation',
        'Lorem Associates',
        'Nunc Quisque Ornare Inc.',
        'Non Quam Pellentesque Corp.',
        'Molestie Industries',
        'Tellus Eu Corporation',
        'Vestibulum Accumsan Neque LLC',
        'Semper Foundation',
        'Convallis Foundation',
        'Ac Eleifend Vitae Foundation',
        'Lectus Nullam Suscipit Incorporated',
        'Sem Nulla Corporation',
        'Eget Limited',
        'Scelerisque Neque Consulting',
        'Mauris Incorporated',
        'Montes Consulting',
        'Et Tristique Pellentesque PC',
        'Dictum Institute',
        'Arcu Ltd',
        'In Tempus Inc.',
        'Ipsum Primis PC',
        'Ornare PC',
        'Phasellus Fermentum Convallis Consulting',
        'Felis Orci Corporation',
        'Vitae LLC',
        'Elementum Dui Quis Consulting',
    ],
    person: [
        'Chantale Prince',
        'Mira Potter',
        'Seth Cook',
        'Grady Atkinson',
        'Luke Bridges',
        'Callum Daugherty',
        'Yvonne Richards',
        'Sebastian Hicks',
        'Irma Bird',
        'Adrian Carr',
        'Halla Padilla',
        'Suki Lucas',
        'Chelsea Estrada',
        'Reese Gilmore',
        'Adria Dejesus',
        'Eleanor Harrell',
        'Denise Joseph',
        'Jena Riley',
        'Guinevere Dennis',
        'Dexter Holt',
        'Candice Johns',
        'September Craig',
        'Catherine Yang',
        'Raphael Hubbard',
        'Tucker Duran',
        'Dominic Knowles',
        'Eagan Garza',
        'Lareina Ferrell',
        'Clio Ayala',
        'Kuame Steele',
        'Xerxes Collins',
        'Tanner Coffey',
        'Julian Hunter',
        'Cruz Barber',
        'Dane Hanson',
        'Leo Avery',
        'Colton Wise',
        'Kane Hamilton',
        'Montana Brooks',
        'Lars Harvey',
        'Cooper Nunez',
        'Maggie Parsons',
        'Ryder Brown',
        'Quamar Terry',
        'Burton Mckenzie',
        'McKenzie Stout',
        'Caldwell Meadows',
        'Chaim Skinner',
        'Sylvester Rivers',
        'Francis Bean',
        'Brooke Gilbert',
        'Ralph Kent',
        'Linus Mcbride',
        'Sydnee Bender',
        'Rooney Skinner',
        'Cameron Franco',
        'Elvis Cortez',
        'Hashim Hooper',
        'Nyssa David',
        'Risa Griffith',
        'Beau Nolan',
        'Justina Fowler',
        'Zane Saunders',
        'Zephr Bradshaw',
        'Josephine Jackson',
        'Lacota Levy',
        'Gannon Floyd',
        'Shellie Vaughn',
        'Kyla Witt',
        'Urielle Graham',
        'Hyatt Mclaughlin',
        'Ingrid Sparks',
        'Donovan Shields',
        'Althea Neal',
        'Kibo Ball',
        'Gwendolyn Cummings',
        'Ivana Rodgers',
        'Vivien Davenport',
        'Amos Farrell',
        'Ali Fleming',
        'Britanni Marks',
        'Preston Schmidt',
        'Anastasia Adkins',
        'Quincy Peters',
        'Lareina Cameron',
        'Chloe Sharp',
        'Mufutau Page',
        'Shellie Burks',
        'Fatima Lancaster',
        'Rooney Carrillo',
        'Akeem Schneider',
        'Malachi Boyle',
        'Clayton Mcfadden',
        'Abraham Blake',
        'Faith Vazquez',
        'Anthony Benjamin',
        'Lane French',
        'Kadeem Greene',
        'Clementine Burton',
        'Isadora Duke',
    ],
    ocpiProfile: ['Integration 1'],
    serial: [
        'K0TONCWZY',
        'K0BSUOTN7',
        'K0ISMUZAA',
        'K0YACR7DI',
        'K0HS10487',
        'K0Y8BLOOA',
        'K0ZNZHXL9',
        'K06QV1RFT',
        'K08037BR9',
        'K065H9X20',
    ],
    randomNumber: [
        '08553226',
        '48432414',
        '45870470',
        '30087914',
        '11046822',
        '33006601',
        '16573326',
        '48936004',
        '75702641',
        '68384851',
        '09851615',
        '86262338',
        '77159965',
        '67720701',
        '38656375',
        '19378661',
        '26059257',
        '63977556',
        '21637327',
        '03123566',
    ],
};
